require('./hireCardRevolvingStep1.scss');
// @ vendors
const PropTypes = require('prop-types');
const React = require('react');

// @helpers
const { FormattedText, formatText } = require('core/i18n').i18n;
const { PROC_CARD_REVOLVING } = require('utilities/tagging');
const { getEmail } = require('utilities/personalDataHelper');

// @ components
const { HireInformation } = require('components/hire/hireInformation/hireInformation');
const HiringProductInformation = require('components/hiringProductInformation/hiringProductInformation');
const { OKCheckbox } = require('commonsComponents/OKCheckbox');
const PreContractualMailInfo = require('components/contactCenter/preContractualMailInfo/preContractualMailInfo');
const ContactCenterRender = require('components/conditionalRender/contactCenterRender');

// @ constants
const {
    CARD_REVOLVING_PRODUCT_SUBTYPE,
    CARD_REVOLVING_PRODUCT_TYPE,
    FIRST_STEP,
} = require('constants/index');

// @constants
const getCardsPreContractPdfData = require('constants/cardsPreContractualsPdf');
const { REVOLVING_CARD_PRDOUCT_ALIAS,
    PRODUCT_HIRING_COMPONENT_ID } = require('constants/hiringProductInformation');
const { GC } = require('constants/flagBasedFeatures');

class HireCardRevolvingStep1 extends React.Component {

    constructor(props){
        super(props);
        this.state = {
            scoringFetched: false,
        };
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        const {
            immHireCardRevolving,
            requestPDFMerge,
            setTermsAndCondsText,
        } = nextProps;

        let stateUpdates = null;

        if (!__CONTACT_CENTER__) {

            if(!prevState.scoringFetched && immHireCardRevolving.get('fetchSuccessScoring')) {
                stateUpdates = {
                    scoringFetched: true
                };
                const pdfurls = getCardsPreContractPdfData()['revolving_card'].preContractPdfLink;
                const product = {
                    standard: immHireCardRevolving.get('referenceStandard'),
                    subtype: CARD_REVOLVING_PRODUCT_SUBTYPE,
                    type: CARD_REVOLVING_PRODUCT_TYPE,
                };
                requestPDFMerge(pdfurls, [product]);
            }
        } else if (!!setTermsAndCondsText) {
            setTermsAndCondsText('hireCardRevolving-step4CheckboxText');
        }

        return stateUpdates;
    }

    buildLegalConfirmationSection() {
        const { immHireInformation, immHiringProductInformation, gestorCrossEnabled } = this.props
        const information = gestorCrossEnabled ? immHiringProductInformation.get('cmsResponse') : immHireInformation.get('information');
        if (!__CONTACT_CENTER__ || !information) {
            return null;
        }

        const {
            contractName,
            handleAgreementCheckboxChange,
            immHireCardRevolving,
            immPreContractualMail,
            immProfile,
            requestProfile,
            sendMailParams,
            sendPreContractualMail,
        } = this.props;

        const clientEmail = getEmail(immProfile);
        const profileError = immProfile.get('error');
        const hasBeenEmailSent = immPreContractualMail.get('mailSent');
        const immStep = immHireCardRevolving.getIn(['steps', FIRST_STEP]);
        const ineUrl = formatText(`hireCardRevolving-step4IneUrlPack${immHireCardRevolving.get('pack')}`);
        const agreementLabel = <FormattedText injectedStrings={[ineUrl]} value="hireCardRevolving-step4CheckboxText" />;
        const agreementChecked = immStep.get('agreementChecked');
        const agreementErrorVisible = immStep.get('agreementIsDirty') && !immStep.get('agreementChecked');
        const agreementErrorMsg = formatText('hireCardRevolving-step4CheckboxErrorMsg');

        return (
            <section className="hire-card-revolving-step-one__legal-confirmation-section">
                <PreContractualMailInfo
                    contractName={contractName}
                    email={clientEmail}
                    preContractualMail={immPreContractualMail}
                    profileError={profileError}
                    requestProfile={requestProfile}
                    sendEmail={sendPreContractualMail}
                    sendMailParams={sendMailParams}
                />
                <div className="hire-card-revolving-step-one__checkbox-container">
                    <OKCheckbox
                        idName="hireCreditCardRevolvingAgreementCheckbox"
                        disabled={!hasBeenEmailSent}
                        errorState={agreementErrorVisible}
                        errorMessage={agreementErrorMsg}
                        label={agreementLabel}
                        onChange={handleAgreementCheckboxChange}
                        value={agreementChecked}
                    />
                </div>
            </section>
        );
    }

    render() {
        const { immHireInformation, gestorCrossEnabled, flagBasedFeatures } = this.props;
        const legalConfirmationSection = this.buildLegalConfirmationSection();
        let productInformationComponent;
        if (gestorCrossEnabled && flagBasedFeatures.get(GC)) {
            productInformationComponent = (
                <React.Fragment>
                    <HiringProductInformation
                        productAlias={REVOLVING_CARD_PRDOUCT_ALIAS}
                        productComponentId={PRODUCT_HIRING_COMPONENT_ID}
                    />
                    <ContactCenterRender>
                        {legalConfirmationSection}
                    </ContactCenterRender>
                </React.Fragment>
            )
        } else {
            productInformationComponent = (
                <article className="hire-card-revolving__step-one">
                    <FormattedText
                        className="hire-card-revolving__step-title"
                        value="hireCardRevolving-step1Title"
                    />
                    <HireInformation
                        hireCmsKey={this.props.hireCmsKey}
                        immHireInformation={immHireInformation}
                        tealiumProcess={PROC_CARD_REVOLVING}
                    />
                    <ContactCenterRender>
                        {legalConfirmationSection}
                    </ContactCenterRender>
                </article>
            )
        }

        return (
            <div>
                {productInformationComponent}
            </div>
        );
    }
}

HireCardRevolvingStep1.propTypes = {
    contractName: PropTypes.string,
    flagBasedFeatures: PropTypes.object.isRequired,
    gestorCrossEnabled: PropTypes.bool,
    handleAgreementCheckboxChange: PropTypes.func,
    hireCmsKey: PropTypes.string.isRequired,
    immHireInformation: PropTypes.object.isRequired,
    immHiringProductInformation: PropTypes.object.isRequired,
    immHireCardRevolving: PropTypes.object,
    immPreContractualMail: PropTypes.object,
    immProfile: PropTypes.object.isRequired,
    requestProfile: PropTypes.func,
    sendMailParams: PropTypes.object,
    sendPreContractualMail: PropTypes.func,
    requestPDFMerge: PropTypes.func.isRequired,
    setTermsAndCondsText: PropTypes.func,
};

module.exports = HireCardRevolvingStep1;
